import styled from 'styled-components';

export const StyledWrapper = styled.div`
  .image-placeholder {
    width: 100%;
    height: 140px;
    overflow: hidden;

    background-color: grey;
    border-radius: 10px;

    color: white;
    text-align: center;

    img {
      width: 100%;
      height: 140px;
      object-fit: cover;
    }

    box-shadow: ${({ theme }) => theme.shadows.low};
  }

  .line {
    height: 1px;
    background: rgba(51, 61, 108, 0.1);
  }

  .section {
    padding-top: 24px;
    padding-bottom: 24px;
  }

  .row {
    margin-bottom: 4px;
  }

  div.tag {
    > img {
      width: 14px;
      height: 14px;
    }

    > span {
      margin-left: 16px;
    }
  }
`;
